module.exports = __webpack_public_path__ + "static/media/Ship-Card.cacbfdff.jpg";